<template>
	<div >
		<van-tabs title-active-color="#2A68F9" :border="true" scrollspy sticky>
			<van-tab class="margin_continue" title="产品分布">
				<div>
					<p class="sub_menu_title">产品分布</p>
					<div class="switch_container">
						<div class="switch" @click="checkoutBox(nodes)">
							<div :class="nodes==0?'switch_child':'switch_hide_right'" @click="nodes=0">
								软件类
							</div>
							<img :class="nodes==0?'animate__animated animate__flash':'nodes_img animate__animated animate__flash'" src="../assets/static/images/jiantt_r.png" style="transform: scale(0.7);position: absolute;left:155px; animation-iteration-count : infinite ;opacity: 0.4; animation-duration : 5s;top: 0.3125rem;">
							<div :class="nodes==1?'switch_child':'switch_hide_left'" @click="nodes=1">
								硬件类
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: center;">
						<div :class="nodes==0?'box_container1':'box_hide'">
							<div class="card_detail" v-for="(item,i) in goodsData" :key="i" v-show="item.type==1">
								<img class="card_logo" :src="item.min_pic" />
								<p class="card_text">
									{{item.title}}
								</p>
								<p class="card_message">
									{{item.sketch}}
								</p>
							</div>
							<!-- <div class="card_detail">
								<img class="card_logo" src="../assets/static/images/yq.png" />
								<p class="card_text">
									仪器管理系统
								</p>
								<p class="card_message">
									实验室仪器收费管理、预约管理相关的数据统计
								</p>
							</div>
							<div class="card_detail">
								<img class="card_logo" src="../assets/static/images/gongx.png" />
								<p class="card_text">
									共享支持系统
								</p>
								<p class="card_message">
									科研资源共享平台和相关的后台仪器管控，统一信息发布功能
								</p>
							</div>
							<div class="card_detail">
								<img class="card_logo" src="../assets/static/images/anquan.png" />
								<p class="card_text">
									实验室安全系统
								</p>
								<p class="card_message">
									实现实验开放资源整合发布、预约使用、统计计费，实现资源合理利用
								</p>
							</div>
							<div class="card_detail">
								<img class="card_logo" src="../assets/static/images/shiyan.png" />
								<p class="card_text">
									危化品管理系统
								</p>
								<p class="card_message">
									确保危化品在使用过程中合法，所有操作数据化可追溯
								</p>
							</div>
							<div class="card_detail">
								<img class="card_logo" src="../assets/static/images/animal.png" />
								<p class="card_text">
									动物管理实验系统
								</p>
								<p class="card_message">
									动物房涵盖人员、动物实验、寄养、生产等方面将其串联起来
								</p>
							</div> -->
						</div>
					</div>
					<div style="display: flex;justify-content: center;margin-top: 4.5rem;">
						<div :class="nodes==1?'box_container2':'box_hide'">
							<div class="card_detail2" v-for="(item,i) in goodsData" :key="i" v-show="item.type==2">
								<img class="card_logo2" :src="item.min_pic">
								<div class="card_right">
									<p class="card_text2">{{item.title}}</p>
									<p class="card_message2">{{item.sketch}}</p>
								</div>
							</div>
							<!-- <div class="card_detail2">
								<img class="card_logo2" src="../assets/static/images/kzq.png">
								<div class="card_right">
									<p class="card_text2">仪器智能控制器</p>
									<p class="card_message2">智能机器硬件控制机器实现物品管理</p>
								</div>
							</div>
							<div class="card_detail2">
								<img class="card_logo2" src="../assets/static/images/jiankong.png">
								<div class="card_right">
									<p class="card_text2">视频监控器</p>
									<p class="card_message2">线上监视实验室环境实时情况</p>
								</div>
							</div>
							<div class="card_detail2">
								<img class="card_logo2" src="../assets/static/images/wendujc.png">
								<div class="card_right">
									<p class="card_text2">环境温度湿度监测器</p>
									<p class="card_message2">实验室温度、湿度监测机器</p>
								</div>
							</div>
							<div class="card_detail2">
								<img class="card_logo2" src="../assets/static/images/yiqizhineng.png">
								<div class="card_right">
									<p class="card_text2">仪器智能控制器</p>
									<p class="card_message2">智能机器硬件控制机器实现物品管理</p>
								</div>
							</div>
							<div class="card_detail2">
								<img style="width: 5rem;margin-left: 1rem;margin-right: 1.5rem;" class="card_logo2"
									src="../assets/static/images/shipinjk.png">
								<div class="card_right">
									<p class="card_text2">视频监控器</p>
									<p class="card_message2">线上监视实验室环境实时情况</p>
								</div>
							</div>
							<div class="card_detail2">
								<img class="card_logo2" src="../assets/static/images/wendujk.png">
								<div class="card_right">
									<p class="card_text2">环境温度湿度监测器</p>
									<p class="card_message2">实验室温度、湿度监测机器</p>
								</div>
							</div>
							<div class="card_detail2">
								<img class="card_logo2" src="../assets/static/images/danger.png">
								<div class="card_right">
									<p class="card_text2">危化品智能管控器</p>
									<p class="card_message2">危化品涉及人身安全实现智能管理</p>
								</div>
							</div>
							<div class="card_detail2">
								<img class="card_logo2" src="../assets/static/images/chaxun.png">
								<div class="card_right">
									<p class="card_text2">定点查询</p>
									<p class="card_message2">实现人员使用权限开启使用冰箱</p>
								</div>
							</div>
							<div class="card_detail2">
								<img class="card_logo2" src="../assets/static/images/qiti.png">
								<div class="card_right">
									<p class="card_text2">气体检测器</p>
									<p class="card_message2">监测二氧化碳或有害气体浓度</p>
								</div>
							</div>
							<div class="card_detail2">
								<img class="card_logo2" src="../assets/static/images/duandian.png">
								<div class="card_right">
									<p class="card_text2">断电报警控制器</p>
									<p class="card_message2">断电即时产生报警反应提醒用户</p>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</van-tab>
			<van-tab class="margin_continue bg_grey" title="客户案例">
				<div>
					<p class="sub_menu_title">客户案例</p>
					<div class="customer_case_container">
						<div v-show="i<3" v-for="(item,i) in customerData" :key="i"
							:class="slideMove==i+1?'card_case cade_case_silde':'card_case'" @mouseover="slideTop(i+1)"
							@mouseleave="slideLeave()">
							<img :src="item.img">
							<p class="case_title">{{item.tilte}}</p>
							<p class="case_message">
								{{item.sketch}}
							</p>
						</div>
						<!-- <div :class="slideMove==1?'card_case cade_case_silde':'card_case'" @mouseover="slideTop(1)"
							@mouseleave="slideLeave()">
							<img src="../assets/static/images/xiehe.png">
							<p class="case_title">中国医学科学院北京协和医院</p>
							<p class="case_message">
								科颐轩为北京协和医院转化医学楼实验室搭建仪器管理系统、共享支持系统、危化品管理系统、实验室安全管理系统、实验动物房管理系统、场地预约系统、文件管理系统等多套管理系统，采用软硬件结合管控的方式，全面实现实验室“开放、共享、公用”的管理理念。
							</p>
						</div>
						<div :class="slideMove==2?'card_case cade_case_silde':'card_case '" @mouseover="slideTop(2)"
							@mouseleave="slideLeave()">
							<img src="../assets/static/images/nanfang.png">
							<p class="case_title">南方医院</p>
							<p class="case_message">
								科颐轩为南方医院搭建仪器管理系统、共享支持系统、危化品管理系统、实验室安全管理系统等多套管理系统。首批采用仪器智能控制器180多台，门禁智能控制器83个，智能储物柜45套，冰箱智能控制器30台。实验室每月流动研究生300多人，配备1名后台管理员，24小时开放无需人员值班。
							</p>
						</div>
						<div :class="slideMove==3?'card_case cade_case_silde':'card_case '" @mouseover="slideTop(3)"
							@mouseleave="slideLeave()">
							<img src="../assets/static/images/shiyans.png">
							<p class="case_title">呼吸疾病国家重点实验室</p>
							<p class="case_message">
								实验室采用科颐轩仪器管理系统，实验室安全管理系统，首批安装150余台仪器智能控制器，实现仪器设备的点到点精细化管理，仪器使用授权、仪器预约、上机使用、故障上报等全流程可视化管理，有效解决仪器管理存在的难题。
							</p>
						</div> -->
						<router-link :to="{path:'/customer/customerCase'}" @click="retrunTOP()">
							<div class="card_case_more">

								<p class="case_title_more">
									加载更多案例
								</p>

							</div>
						</router-link>
					</div>
				</div>
			</van-tab>
			<!-- <van-tab class="margin_continue" title="核心优势" >
			  <div>
			  				  <p class="sub_menu_title">核心优势</p>
			  </div>
		  </van-tab> -->
			<van-tab class="margin_continue" title="客户分布">
				<div>
					<p class="sub_menu_title">客户分布</p>
					<div class="map_container">
						<img class="map" src="../assets/static/images/ditu.png">
						<img :class="animate_end==1?'circle_lage ani_hide':'circle_lage animate__animated animate__bounceIn'"
							src="../assets/static/images/100jia.png">
						<img :class="animate_end==1?'circle_mlddle_l ani_hide':'circle_mlddle_l animate__animated animate__bounceIn'"
							src="../assets/static/images/30ss.png">
						<img :class="animate_end==1?'circle_mlddle_r ani_hide':'circle_mlddle_r animate__animated animate__bounceIn'"
							src="../assets/static/images/lzgz.png">
						<img :class="animate_second==1?'local_b_1 ani_hide':'local_b_1 animate__animated animate__heartBeat'"
							src="../assets/static/images/local_b.png">
						<img :class="animate_second==1?'local_b_2 ani_hide':'local_b_2 animate__animated animate__heartBeat'"
							src="../assets/static/images/local_b.png">
						<img :class="animate_second==1?'local_b_3 ani_hide':'local_b_3 animate__animated animate__heartBeat'"
							src="../assets/static/images/local_b.png">
						<img :class="animate_second==1?'local_b_4 ani_hide':'local_b_4 animate__animated animate__heartBeat'"
							src="../assets/static/images/local_b.png">
						<img :class="animate_second==1?'local_b_5 ani_hide':'local_b_5 animate__animated animate__heartBeat'"
							src="../assets/static/images/local_b.png">
						<img :class="animate_second==1?'local_b_6 ani_hide':'local_b_6 animate__animated animate__heartBeat'"
							src="../assets/static/images/local_b.png">
						<img :class="animate_second==1?'local_b_7 ani_hide':'local_b_7 animate__animated animate__heartBeat'"
							src="../assets/static/images/local_b.png">
						<img :class="animate_second==1?'local_b_8 ani_hide':'local_b_8 animate__animated animate__heartBeat'"
							src="../assets/static/images/local_b.png">
						<img :class="animate_first==1?'local_a ani_hide':'local_a animate__animated animate__flash'"
							src="../assets/static/images/local_a.png">
						<img :class="animate_three==1?'xian_a ani_hide':'xian_a animate__animated animate__fadeIn '"
							src="../assets/static/images/xian_a.png">
						<img :class="animate_three==1?'xian_b ani_hide':'xian_b animate__animated animate__fadeIn '"
							src="../assets/static/images/xian_b.png">
						<img :class="animate_three==1?'xian_c ani_hide':'xian_c animate__animated animate__fadeIn '"
							src="../assets/static/images/xian_c.png">
						<img :class="animate_three==1?'xian_d ani_hide':'xian_d animate__animated animate__fadeIn '"
							src="../assets/static/images/xian_d.png">
					</div>
				</div>
			</van-tab>
			<van-tab class="margin_continue bg_grey" title="公司资质">
				<div class="natural">
					<p class="sub_menu_title">公司资质</p>
					<div class="natural_container">
						<el-carousel :interval="4000" type="card" height="18.75rem" @change="seledCarousel"
							ref="natural_carousel">
							<el-carousel-item style="background-color: transparent;" index="i"
								v-for="(item,i) in compData">
								<img style="width: 100%;height: auto;  background-size: 100% ;" :src="item.img" preview :preview-text="item.title+'<br>'+item.ctitle">
							</el-carousel-item>
							<!-- <el-carousel-item style="background-color: transparent;" index="1" >
								<img style="width: 100%;height: auto;  background-size: 100% ;"
									src="../assets/static/images/zhengshu_a.png">
							</el-carousel-item>
							<el-carousel-item style="background-color: transparent;" key="2">
								<img style="width: 100%;height: auto;  background-size: 100% ;"
									src="../assets/static/images/zhengshu_b.png">
							</el-carousel-item>
							<el-carousel-item style="background-color: transparent;" key="3">
								<img style="width: 100%;height: auto;  background-size: 100% ;"
									src="../assets/static/images/zhengshu_c.png">
							</el-carousel-item> -->
						</el-carousel>
						<div class="natural_message">
							<div>
								<div class="natural_msg">
									<div @mouseover="slideCarousel(i)" v-for="(item,i) in compData" :key="i">
										<div class="natural_dot_box">
											<p class="dot"></p>
											<div
												:class="carousel_index==i?'natural_text natural_text_selected':'natural_text'">
												{{item.title}}
											</div>
										</div>
										<p
											:class="carousel_index==i?'natural_data natural_data_selected':'natural_data'">
											{{item.ctitle}}
										</p>
									</div>
									<!-- <div @mouseover="slideCarousel(0)">
										<div class="natural_dot_box">
											<p class="dot"></p>
											<div
												:class="carousel_index==0?'natural_text natural_text_selected':'natural_text'">
												国家高新技术企业
											</div>
										</div>
										<p
											:class="carousel_index==0?'natural_data natural_data_selected':'natural_data'">
											持续研究与开发成果转为自主知识产权
										</p>
									</div>
									<div @mouseover="slideCarousel(1)">
										<div class="natural_dot_box">
											<p class="dot"></p>
											<div
												:class="carousel_index==1?'natural_text natural_text_selected':'natural_text'">
												广东省守合同重信用企业
											</div>
										</div>
										<p
											:class="carousel_index==1?'natural_data natural_data_selected':'natural_data'">
											企业以遵守合同内容为守则，诚信经营
										</p>
									</div>
									<div>
										<div class="natural_dot_box" @mouseover="slideCarousel(2)">
											<p class="dot"></p>
											<div
												:class="carousel_index==2?'natural_text natural_text_selected':'natural_text'">
												环境管理体系认证
											</div>
										</div>
										<p
											:class="carousel_index==2?'natural_data natural_data_selected':'natural_data'">
											企业生产经验不违反保护环境条例
										</p>
									</div> -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-tab>
			<van-tab class="margin_continue" title="新闻资讯">
				<div>
					<p class="sub_menu_title">新闻资讯</p>
					<div class="news_container">

						<div class="news_detail_l" @click="goToNewsDetail(item)" v-for="(item,i) in leftNewsData"
							:key="i" v-if="i==0">
							<p class="news_title_date">
								{{item.ReleaseDate.substr(0,10)}}
							</p>
							<p class="news_title">
								{{item.title}}
							</p>
							<p class="news_msg">
								{{item.sketch}}
							</p>
							<img class="news_img" :src="item.img">
						</div>
						<div class="news_right_container" style="position: relative;">
							<p style="margin: 0;padding: 0;">
								<router-link class="more" :to="{path:'/news/newsList'}">更多 ></router-link>
							</p>
							<div :style="i==2?'border-top: none;border-bottom: 0.0625rem solid #D4D4D4;':''"
								class="news_detail_r" v-for="(item,i) in rightNewsData" :key="i"
								@click="goToNewsDetail(item)" v-if="i<3">
								<div class="news_message_box">
									<div class="news_message_title">
										<div class="dot"></div>
										<div class="news_message_text">
											{{item.title}}
										</div>
										<div class="news_message_date">
											{{item.ReleaseDate.substr(0,10)}}
										</div>
									</div>
									<p class="news_message_data">
										{{item.releaseunit}}
									</p>
								</div>
							</div>

						</div>
					</div>
				</div>
			</van-tab>
			<van-tab class="partners margin_continue2" title="合作客户">
				<p class="sub_menu_title">合作客户，共创未来</p>
				<div class="white_left">

				</div>
				<div class="white_right">

				</div>

				<!-- <div style="">
			  				 
							  <div class="partners_container">
								  <div class="partners_box_t">
									 <img class="partners_img" src="../assets/static/images/bei_xiehe.png">
									 <img class="partners_img" src="../assets/static/images/sichuan.png">
									 <img class="partners_img" src="../assets/static/images/nanfang_xy.png">
									 <img class="partners_img" src="../assets/static/images/huxi.png">
								  </div>
								  <div class="partners_box_b">
								  									  <img class="partners_img" src="../assets/static/images/renmin.png">
																	  <img class="partners_img" src="../assets/static/images/yikeda.png">
																	  <img class="partners_img" src="../assets/static/images/zhongnan.png">
																	  <img class="partners_img" src="../assets/static/images/yingji.png">
								  </div>
							  </div>
			  </div> -->
				<div class="animate_top">

					<div class="tech-slideshow">
						<div class="mover-1" ref="mover_t">
							<img :src="item.img" v-for="(item,i) in selCustomerData" :key="i">
							<img  :src="item.img" v-for="(item,i) in selCustomerData"  v-show="i<4">
						</div>
						
					</div>
				</div>
				<div class="animate_bottom">
					<div class="tech-slideshow">
						<div class="mover-1" ref="mover_b">
						<img :src="item.img" v-for="(item,i) in selCustomerData" :key="i">
						<img :src="item.img" v-for="(item,i) in selCustomerData"   v-show="i<4">
						</div>
						
					</div>
				</div>

			</van-tab>
		</van-tabs>
	</div>
</template>
<script>
	import {
		newsList,
		customer,
		hardware,
		banner,
		comp,
		goods,
		selCustomer
	} from '../common/api.js'
	export default {
		name: "index",
		data() {
			return {
				comp,
				goods,
				customer,
				banner,
				newsList,
				selCustomer,
				hardware,
				nodes: 0,
				box_nodes: 0,
				animate_first: 1,
				animate_second: 1,
				animate_three: 1,
				animate_end: 1,
				flash: 1,
				slideMove: -1,
				carousel_index: 0,
				leftNewsData: [],
				rightNewsData: [],
				compData: [],
				customerData: [],
				goodsData: [],
				selCustomerData:[]
			};
		},
		async mounted() {
			window.addEventListener('scroll', this.scrollToTop)
			let res = await this.selCustomer({
				PageIndex: 1,
				PageSize: 10000
			});
			const selCustomerData = res.data.Data
			console.log(this.selCustomerData.length)
			this.$refs.mover_t.style.width=selCustomerData.length*489+'px'
			this.$refs.mover_b.style.width=selCustomerData.length*489+'px'
		},
		created() {
			this.getNewsList("1", 1, 10000)
			this.getNewsList("2", 1, 10000)
			this.getCustomer()
			this.getComp()
			this.getGoods()
			this.getSelCustomer()
			this.$store.commit('savePath',"试试")
		},
		methods: {
			//监听页面位置，达到条件执行图标动画
		 async	ceshi() {
				const res = await this.$http.post("", {
					page: 1,
					total: 69,
					limit: 16,
				})
				console.log(res)
			},
			scrollToTop() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				console.log(scrollTop)
				let docHeight = document.querySelector('.map_container').offsetTop;
				console.log(docHeight)
				if (scrollTop >= docHeight) {
					window.removeEventListener("scroll", this.scrollToTop)
					console.log('执行')
					var that = this;
					setTimeout(function() {
						that.animate_first = 0
					}, 500)
					setTimeout(function() {
						that.animate_second = 0
					}, 1000)
					setTimeout(function() {
						that.animate_three = 0
					}, 1500)
					setTimeout(function() {
						that.animate_end = 0
					}, 2000)
				}
			},
			slideTop(i) {
				this.slideMove = i;
			},
			slideLeave() {
				this.slideMove = -1;
			},
			seledCarousel(index) {
				this.carousel_index = index;
			},
			goToNewsDetail(item) {
				console.log(item)
				this.$router.push({
					path: '/news/newsDetail',
					query: {
						id: item.Id
					}
				})
			},
			slideCarousel(i) {
				console.log("dd")
				this.$refs.natural_carousel.setActiveItem(i)
			},
			async getCustomer() {
				let res = await this.customer( {
					PageIndex: 1,
					PageSize: 10000
				});
				this.customerData = res.data.Data
			},
			async getSelCustomer() {
				let res = await this.selCustomer({
					PageIndex: 1,
					PageSize: 10000
				});
				this.selCustomerData = res.data.Data
			},
			async getComp(i) {
				let res = await this.comp()
				console.log(res)

				this.compData = res.data.Data
				console.log("所以")
				console.log(this.compData)
			},
			async getGoods() {
				let res = await this.goods( {
					PageIndex: 1,
					PageSize: 10000
				});
				this.goodsData = res.data.Data
			},
			async getNewsList(type, pageNum, pageSize) {
				if (type === '1') {
					var res = await this.newsList({
						type: type,
						PageIndex: pageNum,
						PageSize: pageSize
					})
					this.leftNewsData = res.data.Data
				}
				if (type === '2') {
					var res = await this.newsList({
						type: type,
						PageIndex: pageNum,
						PageSize: pageSize
					})
					this.rightNewsData = res.data.Data
				}
				console.log(this.leftNewsData)
				console.log("总数")
				console.log(this.rightNewsData)
			},
		}
	}
</script>

<style lang="less" scoped>
	.switch_container {
		display: flex;
		justify-content: center;
	}

	.switch {
		display: flex;
		width: 12.75rem;
		height: 3.375rem;
		background: #F3F3F3;
		border-radius: 1.6875rem;
		cursor: pointer;
		position: relative;
		
		.nodes_img{
			left: 0.625rem !important;
		}
		.switch_child {
			width: 6.375rem;
			height: 3.375rem;
			background: #FFFFFF;
			box-shadow: 0 0.3125rem 0.4375rem 0.125rem #DDDDDD;
			border-radius: 2.125rem;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 1.125rem;
			font-weight: 400;
			color: #333333;
			transition-duration: 1s;
		}

		.right_hide {
			transform: translateX(233px);
		}

		@keyframes right_move {
			10% {
				transform: translateX(20px);
			}

			30% {
				transform: translateX(50px);
			}

			50% {
				transform: translateX(70px);
			}

			70% {
				transform: translateX(80px);
			}

			90% {
				transform: translateX(101);
			}

			100% {
				opacity: 0;
			}
		}

		@keyframes left_move {
			10% {
				transform: translateX(-20px);
			}

			30% {
				transform: translateX(-50px);
			}

			50% {
				transform: translateX(-70px);
			}

			70% {
				transform: translateX(-80px);
			}

			80% {
				transform: translateX(-101);
			}

			100% {
				opacity: 0;
			}
		}

		.switch_hide_right {
			width: 6.375rem;
			height: 3.375rem;
			background: #FFFFFF;
			box-shadow: 0 0.3125rem 0.4375rem 0.125rem #DDDDDD;
			border-radius: 2.125rem;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 1.125rem;
			font-weight: 400;
			color: #333333;
			animation: right_move 0.5s;
			animation-fill-mode: forwards;
			animation-iteration-count: 1;
			// opacity: 0;
			z-index: 2;
		}

		.switch_hide_left {
			width: 6.375rem;
			height: 3.375rem;
			background: #FFFFFF;
			box-shadow: 0 0.3125rem 0.4375rem 0.125rem #DDDDDD;
			border-radius: 2.125rem;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 1.125rem;
			font-weight: 400;
			color: #333333;
			animation: left_move 0.5s;
			animation-fill-mode: forwards;
			animation-iteration-count: 1;
			// opacity: 0;
		}

	}

	.box_container {
		width: 100%;
	}

	.box_hide {
		width: 100%;
		opacity: 0;
		display: none;
	}

	.box_container1 {
		width: 75rem;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		margin-top: 6.75rem;
	}
	.card_detail {
		display: flex;
		justify-content: baseline;
		align-items: center;
		flex-direction: column;
		width: 13.75rem;
		height: 16.25rem;
		background: #FFFFFF;
		box-shadow: 0 0.125rem 0.5625rem 0.3125rem rgba(221, 221, 221, 0.5);
		padding-top: 2rem;
	}
	@keyframes pulse { /*变大变小*/
	    from {
	        transform: scale3d(1, 1, 1);
	    }
	 
	    50% {
	        transform: scale3d(1.05, 1.05, 1.05);
	    }
	    to {
	        transform: scale3d(1, 1, 1);
	    }
	}
	.card_detail:hover {
		box-shadow: 0 0.125rem 0.5625rem 0.3125rem rgba(221, 221, 221, 0.9);
		
	}
	.card_detail:hover .card_logo{
		    animation: pulse 1s;
	}
	.card_detail2:hover {
		box-shadow: 0 0.125rem 0.5625rem 0.3125rem rgba(221, 221, 221, 0.9);
	}
	@keyframes pulse2 { /*变大变小*/
	    from {
			transform: scale(0.6);
	    }
	 
	    50% {
	        transform: scale(0.65);
	    }
	    to {
		
	       transform: scale(0.6);
	    }
	}
	.card_detail2:hover .card_logo2{
		  
		    animation: pulse2 1.25s;
	}
	.card_logo {
		margin-bottom: 0.375rem;

		height: 5.5rem;
	}

	.card_text {
		font-size: 1rem;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #333333;
		margin-top: 1.5rem;
		margin-bottom: 0.5rem;
	}

	.card_message {
		margin-top: -0.3125rem;
		font-size: 0.75rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		text-align: center;
		margin: 0 1.5625rem;
		line-height: 1.0625rem;
	}

	.box_container2 {
		width: 75rem;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.card_detail2 {
		display: flex;
		width: 32%;
		height: 8.125rem;
		background: #FFFFFF;
		box-shadow: 0 0.125rem 0.5625rem 0.3125rem rgba(221, 221, 221, 0.5);
		margin-top: 1.875rem;

	}

	.card_right {
		display: flex;
		flex-direction: column;
		justify-content: center;
		margin-left: -0.7rem;
		margin-top: 0.6rem;
	}

	.card_text2 {
		font-size: 1rem;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #333333;
	}

	.card_message2 {
		font-size: 1rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		margin-top: -0.625rem;
	}

	.card_logo2 {
		width: 7.5rem;
		transform: scale(0.6);
	}

	.card_case {
		width: 16.75rem;
		height: 22.1875rem;
		background: #FFFFFF;
		border-radius: 0.375rem;
		margin: 0 1rem;
		box-shadow: 0 0.125rem 0.5625rem 0.125rem rgba(204, 204, 204, 0.5);
	}

	.cade_case_silde {
		margin-top: -0.3125rem;
		box-shadow: 0 0.325rem 0.6625rem 0.325rem rgba(204, 204, 204, 0.5);
		transition: 0.4s;
	}

	.card_case_more {
		width: 16.75rem;
		height: 22.1875rem;
		background: linear-gradient(130deg, #F1F6FF 0%, #C6D8FF 100%);
		box-shadow: 0 0.125rem 0.5625rem 0.125rem rgba(204, 204, 204, 0.5);
		border-radius: 0.375rem;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 1rem;
		cursor: pointer;

	}

	.case_title_more {
		font-size: 1rem;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		// color: #5C8DFF;
		color: grey;
		line-height: 1.375rem;
	}

	.card_case_more:hover {
		opacity: 0.8;
	}

	.card_case_more:hover .case_title_more {
		color: #5C8DFF;
	}

	.customer_case_container {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.case_title {
		font-size: 1rem;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #333333;
		line-height: 1.375rem;
		text-align: center;
		margin-top: 1rem;
	}

	.case_message {
		font-size: 0.75rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 1.0625rem;
		padding: 0 0.9375rem;
	}

	.map_container {
		position: relative;
		width: 46.875rem;
		margin: 0 auto;
	}

	.map {
		width: 46.875rem;
		transform: scale(0.9);

	}

	.circle_lage {
		position: absolute;
		left: 8%;
		top: 6%;
	}

	.circle_mlddle_l {
		position: absolute;
		left: 0;
		top: 30%;
	}

	.circle_mlddle_r {
		position: absolute;
		left: 14%;
		top: 42%;
	}

	.local_b_1 {
		position: absolute;
		left: 36%;
		top: 47%;
		transform: scale(0.7);
	}

	.local_b_2 {
		position: absolute;
		left: 29%;
		top: 55%;
		transform: scale(0.7);
	}

	.local_b_3 {
		position: absolute;
		left: 50%;
		top: 47%;
		transform: scale(0.7);
	}

	.local_b_4 {
		position: absolute;
		left: 47%;
		top: 59%;
		transform: scale(0.7);
	}

	.local_b_5 {
		position: absolute;
		left: 55%;
		top: 68%;
		transform: scale(0.7);
	}

	.local_b_6 {
		position: absolute;
		left: 58%;
		top: 40%;
		transform: scale(0.7);
	}

	.local_b_7 {
		position: absolute;
		left: 68%;
		top: 57%;
		transform: scale(0.7);
	}

	.local_b_8 {
		position: absolute;
		left: 84%;
		top: 12%;
		transform: scale(0.7);
	}

	.local_a {
		position: absolute;
		left: 67%;
		top: 74%;
		transform: scale(0.7);
	}

	.ani_hide {
		visibility: hidden;
	}

	.xian_a {
		position: absolute;
		left: 44%;
		top: 77%;
		transform: scale(0.8) !important;
	}

	.xian_b {
		position: absolute;
		top: 53%;
		left: 53%;

		transform: scale(0.8) !important;
	}

	.xian_c {
		position: absolute;
		transform: scale(0.9) !important;
		top: 43%;
		left: 64.5%;
	}

	.xian_d {
		position: absolute;
		transform: scale(0.8) !important;
		left: 68%;
		top: 14%;
	}

	.natural {
		.el-carousel {
			width: 38.75rem;
		}

		.natural_container {
			display: flex;
			justify-content: center;
		}

		.el-carousel__item {
			width: 13.875rem;
			height: 18.75rem;
		}
	}

	.margin_continue {
		padding: 5rem 0;
	}

	.bg_grey {
		background: #F9FAFC;
	}

	.natural_message {
		.natural_dot_box {
			display: flex;
			align-items: baseline;
			cursor: pointer;
		}

		.natural_text {
			font-size: 1.75rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
		}

		.natural_text_selected {
			color: #004BF9;
		}

		.natural_data_selected {
			color: #6392FF !important;
		}

		.natural_data {
			margin-left: 1.25rem;
			font-size: 1.125rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			margin-top: 0.1875rem;
		}

		.dot {
			width: 0.75rem;
			height: 0.75rem;
			background: #004BF9;
			border-radius: 50%;
			margin-right: 0.625rem;
		}
	}

	.natural_msg {
		margin-left: 5rem;
	}

	.news_container {
		display: flex;
		justify-content: center;
		padding-top: 2rem;

		.more {
			font-size: 20px;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			position: absolute;
			right: 0;
			top: -2.5rem;
			color: #FA3C36;
			cursor: pointer;
			opacity: 0.8;
		}

		.more:hover {
			margin-top: -2px;
			margin-bottom: 2px;
			opacity: 1;
			transition-duration: 0.5s;
		}

		.news_detail_l {
			width: 32rem;
			height: 35.1875rem;
			background: #F8F8F8;
			border-radius: 0.375rem;
			display: flex;
			flex-direction: column;
			align-items: baseline;
			justify-content: center;
			padding: 0 4rem;
		}

		.news_detail_l:hover {
			margin-top: -0.3125rem;
			box-shadow: 0 0.325rem 0.6625rem 0.325rem rgba(204, 204, 204, 0.5);
			transition: 0.4s;
			cursor: pointer;
			margin-bottom: 0.3125rem
		}

		.news_img {
			width: 100%;
			height: 14.4375rem;
			margin-top: 2.3rem;
		}

		.news_title_date {
			font-size: 1.5rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
			margin-top: -2.5rem;
		}

		.news_title {
			font-size: 1.125rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
			margin-top: -0.1rem;
		}

		.news_msg {
			font-size: 0.875rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			word-break: break-word;
			white-space: pre-line;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
		}
	}

	.news_detail_r {
		.news_right_container {
			position: relative !important;
			display: flex;
			flex-direction: column;

		}

		margin-left: 3rem;
		width: 39rem;

		.news_message_box {
			height: 11.58625rem;
			padding: 2.7rem 0;
			border-top: 0.0625rem solid #D4D4D4;
			cursor: pointer;
		}

		.news_message_box:hover .news_message_text {
			color: #3678FA;
		}

		.news_message_box:hover .news_message_date {
			color: #4782F6;
		}

		.news_message_box:hover .news_message_data {
			color: #4782F6;
		}

		.news_message_box:hover .dot {
			background: linear-gradient(180deg, #54A1FD 0%, #2A68F9 100%);
		}

		.news_message_title {
			display: flex;
			align-items: baseline;
		}

		.news_message_text {
			flex: 1;
			font-size: 1.125rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
			margin-left: 0.8rem;
		}

		.dot {
			width: 0.375rem;
			height: 0.375rem;
			background: #D8D8D8;

			border-radius: 50%;
			align-self: center;
		}

		.news_message_date {
			font-size: 1.5rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
		}

		.news_message_data {
			font-size: 0.875rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			line-height: 1.25rem;
			width: 21.5rem;
			margin-left: 1rem;
			padding-top: 0.5rem;
			word-break: break-word;
			white-space: pre-line;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;

		}
	}

	.partners {
		position: relative;
		width: 75rem;
		margin: 0 auto;
		background-image: url(../assets/static/images/ditu_bg.png);
		height: 38rem;
		background-size: 100%;

		.white_left {
			width: 12.5rem;
			height: 100%;
			background-image: linear-gradient(270deg, hsla(0, 0%, 100%, 0) 10%, #fff 50%);
			z-index: 999;
			position: absolute;
			bottom: 0;
			left: -0.3125rem;

		}

		.white_right {
			width: 12.5rem;
			height: 100%;
			background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0) 10%, #fff 50%);
			z-index: 999;
			position: absolute;
			bottom: 0;
			right: -0.3125rem;

		}

		.partners_container {
			display: flex;
			flex-direction: column;
			align-items: center;
		}

		.partners_img {
			border-radius: 0.375rem;
		}

		.partners_box_t {
			margin-left: 8.75rem;
		}

		.partners_box_b {
			margin-left: -8.75rem;
		}
	}

	.margin_continue2 {
		padding-top: 2rem;

	}

	.animate_top {
		.tech-slideshow {
			height: 200px;
			max-width: 1200px;
			margin: 0 auto;
			position: relative;
			overflow: hidden;
			transform: translate3d(0, 0, 0);
		}

		.tech-slideshow>div {
			height: 200px;
			width: 244.5rem;
			// background: url(../assets/static/images/customer_top_r.png);
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;
			transform: translate3d(0, 0, 0);
		}

		.tech-slideshow .mover-1 {
			animation: moveSlideshow 40s linear infinite;
		}

		@keyframes moveSlideshow {
			100% {
				transform: translateX(-66.6666%);
			}
		}
	}

	.animate_bottom {
		box-shadow: 0 0.125rem 0.5625rem 0.125rem rgb(204 204 204 / 50%);

		.tech-slideshow {
			height: 200px;
			max-width: 1200px;
			margin: 0 auto;
			position: relative;
			overflow: hidden;
			transform: translate3d(0, 0, 0);
		}

		.tech-slideshow>div {
			height: 200px;
			width: 489px*8;
			// background: url(../assets/static/images/customer_bottom.jpg);
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;
			transform: translate3d(0, 0, 0);
		}

		.tech-slideshow .mover-1 {
			animation: moveSlideshow 15s linear infinite;
		}

		.tech-slideshow .mover-2 {
			opacity: 0;
			transition: opacity 0.5s ease-out;
			background-position: 0 -200px;
			animation: moveSlideshow 10s linear infinite;
		}

		// .tech-slideshow:hover .mover-2 {
		// 	opacity: 1;
		// }

		@keyframes moveSlideshow {
			100% {
				transform: translateX(-66.6666%);
			}
		}

	}
</style>
